import React from 'react';
import Icon from '../../../components/AppIcon';

const TrendAnalysis = ({ analysisHistory, patterns, nextSteps }) => {
  const totalPhotos = analysisHistory?.reduce((sum, session) => sum + session?.photoCount, 0);
  const avgImprovement = analysisHistory?.length > 1
    ? ((analysisHistory?.[0]?.averageScore - analysisHistory?.[analysisHistory?.length - 1]?.averageScore) / (analysisHistory?.length - 1))?.toFixed(2)
    : 0;

  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Stats Overview - Single Column on Mobile */}
      <div className="grid grid-cols-1 gap-4 sm:gap-6">
        <div className="bg-card rounded-xl p-5 sm:p-6 border border-border">
          <div className="flex items-center gap-2.5 sm:gap-3 mb-2">
            <Icon name="Image" size={20} color="#9333EA" />
            <span className="text-sm sm:text-sm text-muted-foreground">Total Photos Analyzed</span>
          </div>
          <div className="text-3xl sm:text-3xl font-bold text-foreground">{totalPhotos}</div>
        </div>
        <div className="bg-card rounded-xl p-5 sm:p-6 border border-border">
          <div className="flex items-center gap-2.5 sm:gap-3 mb-2">
            <Icon name="Calendar" size={20} color="#0891B2" />
            <span className="text-sm sm:text-sm text-muted-foreground">Analysis Sessions</span>
          </div>
          <div className="text-3xl sm:text-3xl font-bold text-foreground">{analysisHistory?.length}</div>
        </div>
        <div className="bg-card rounded-xl p-5 sm:p-6 border border-border">
          <div className="flex items-center gap-2.5 sm:gap-3 mb-2">
            <Icon name="TrendingUp" size={20} color="#10B981" />
            <span className="text-sm sm:text-sm text-muted-foreground">Avg Improvement/Session</span>
          </div>
          <div className="text-3xl sm:text-3xl font-bold text-foreground">
            {avgImprovement > 0 ? '+' : ''}{avgImprovement}
          </div>
        </div>
      </div>

      {/* Best Photo Patterns */}
      <div className="bg-card rounded-xl p-5 sm:p-6 border border-border">
        <div className="flex items-center gap-2.5 sm:gap-3 mb-4">
          <div className="bg-purple-100 rounded-full p-2.5 sm:p-2">
            <Icon name="Star" size={20} color="#9333EA" />
          </div>
          <h3 className="text-base sm:text-lg font-semibold text-foreground">Your Best Photo Patterns</h3>
        </div>
        <div className="grid grid-cols-1 gap-3 sm:gap-4">
          {patterns?.map((pattern, index) => (
            <div key={index} className="flex items-start gap-2.5 sm:gap-2 bg-muted/30 rounded-lg p-4">
              <Icon name="CheckCircle" size={18} color="#10B981" className="mt-0.5 flex-shrink-0" />
              <span className="text-sm sm:text-sm text-foreground leading-relaxed">{pattern}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Next Steps */}
      <div className="bg-gradient-to-r from-orange-500 to-pink-500 rounded-xl p-5 sm:p-6 text-white">
        <div className="flex items-start gap-3 sm:gap-4">
          <div className="bg-white/20 rounded-full p-2.5 sm:p-3 flex-shrink-0">
            <Icon name="Target" size={20} color="#FFFFFF" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg sm:text-xl font-bold mb-4">Recommended Next Steps</h3>
            <ul className="space-y-3">
              {nextSteps?.map((step, index) => (
                <li key={index} className="flex items-start gap-2.5 sm:gap-2">
                  <span className="bg-white/20 rounded-full min-w-[28px] min-h-[28px] sm:min-w-[24px] sm:min-h-[24px] flex items-center justify-center text-xs font-bold flex-shrink-0">
                    {index + 1}
                  </span>
                  <span className="text-sm sm:text-base text-white/90 leading-relaxed">{step}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrendAnalysis;